import React from 'react';
import vid1 from './img/newvid (1).mp4';
import vid2 from './img/newvid (2).mp4';


const Videos = () => {
  return (
    <div className="videos-container">
      <h2>Our Videos </h2>
      <div className="video-wrapper">
        <div className="video-item">
          <video controls width="100%">
            <source src={vid1} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
        </div>
        
        <div className="video-item">
          <video controls width="100%">
            <source src={vid2} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
        </div>
      </div>
    </div>
  );
};

export default Videos;